import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, FileText } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { personal } = portfolioData;

  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <Link to="/" className="text-2xl font-heading font-extrabold tracking-tight silver-text mb-4 inline-block">
              {personal.name}
            </Link>
            <p className="text-sm text-zinc-400 mb-2">{personal.title}</p>
            <p className="text-sm text-zinc-600">{personal.location}</p>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4 text-zinc-200 text-sm uppercase tracking-[0.2em]">Explore</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-zinc-400 hover:text-white transition-colors">Home</Link></li>
              <li><a href="/#work" className="text-sm text-zinc-400 hover:text-white transition-colors">Work</a></li>
              <li><a href="/#about" className="text-sm text-zinc-400 hover:text-white transition-colors">About</a></li>
              <li><a href="/#contact" className="text-sm text-zinc-400 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold mb-4 text-zinc-200 text-sm uppercase tracking-[0.2em]">Connect</h3>
            <div className="flex space-x-3">
              <a href={personal.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin"
                className="glass-btn w-11 h-11 rounded-full flex items-center justify-center text-zinc-300 hover:text-white">
                <Linkedin size={18} />
              </a>
              <a href={`mailto:${personal.email}`} data-testid="footer-email"
                className="glass-btn w-11 h-11 rounded-full flex items-center justify-center text-zinc-300 hover:text-white">
                <Mail size={18} />
              </a>
              <a href={personal.resumeUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-resume"
                className="glass-btn w-11 h-11 rounded-full flex items-center justify-center text-zinc-300 hover:text-white">
                <FileText size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center">
          <p className="text-sm text-zinc-600">© {currentYear} {personal.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
